<div mat-dialog-title class="flex items-start justify-between w-full mt-3">
  <div class="flex flex-col items-start flex-1">
    <span class="font-bold text-2xl primary-color">Información laboral</span>
    <span class="text-sm text-gray-500">Los campos marcados con * son obligatorios.</span>
  </div>
  <div class="flex items-center pr-1">
    <!-- <i class="pi pi-exclamation-triangle danger-color" style="font-size: 3rem"></i> -->
  </div>
</div>
<mat-dialog-content>
  <form [formGroup]="form" miForm class="styled-form p-fluid">
    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('empresa', 'El nombre de la empresa es requerido')">
      <label for="empresa">Empresa *</label>
      <input pInputText formControlName="empresa" placeholder="Empresa" />
    </div>

    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('cargo', 'El cargo es requerido')">
      <label>Cargo*</label>
      <input pInputText formControlName="cargo" placeholder="Cargo" />
    </div>

    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('funciones', 'Las funciones son requeridas')">
      <label for="funciones">Funciones *</label>
      <textarea
        pTextarea
        id="funciones"
        formControlName="funciones"
        rows="4"
        cols="30"
        placeholder="Escribe aquí..."
      ></textarea>
    </div>

    <div [miCol]="6" miFormField>
      <mat-checkbox formControlName="actLab">
        <label for="actLab">¿Este es tu trabajo actual?</label>
      </mat-checkbox>
    </div>

    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('mesIni', 'El mes de inicio es requerido')">
      <label>Mes de inicio *</label>
      <p-select
        formControlName="mesIni"
        [options]="monthsList"
        placeholder="Mes de inicio"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        appendTo="body"
      ></p-select>
    </div>

    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('anoIni', 'El año de inicio es requerido')">
      <label>Año de inicio *</label>
      <p-select
        formControlName="anoIni"
        [options]="yearsList"
        placeholder="Año de inicio"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        appendTo="body"
      ></p-select>
    </div>

    @if (!form.get('actLab')?.value) {
    <div
      [miCol]="6"
      miFormField
      [miFormFieldError]="getErrorMessage('mesFin', 'El mes de finalización es requerido')"
    >
      <label>Mes de finalización *</label>
      <p-select
        formControlName="mesFin"
        [options]="monthsList"
        placeholder="Mes de finalización"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        appendTo="body"
      ></p-select>
    </div>
    }

    @if (!form.get('actLab')?.value) {
    <div
      [miCol]="6"
      miFormField
      [miFormFieldError]="getErrorMessage('anoFin', 'El año de finalización es requerido')"
    >
      <label>Año de finalización *</label>
      <p-select
        formControlName="anoFin"
        [options]="yearsList"
        placeholder="Año de finalización"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        appendTo="body"
      ></p-select>
    </div>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-content-end gap-2">
  <button miButton="back" [miButtonIcon]="'solar:close-circle-broken'" (click)="closeDialog(false)">Cerrar</button>
  <button miButton="primary" [disabled]="form.invalid" type="submit" (click)="isEdit ? onEdit() : onCreate()">
    {{ isEdit ? 'Actualizar' : 'Guardar' }}
  </button>
</mat-dialog-actions>
